<div *ngIf="showLoader" class="full-page-loader">
	<nz-spin nzTip="{{'general.loaderMessage' | translate}}..."></nz-spin>
</div>
